import React, {Component} from "react";
import {connect} from "react-redux";
import SelectedItem from "../items/SelectedItem";

import "./CarouselItem.css";

class CarouselItem extends Component {

  render() {
    const {title, subtitle, children, showSelected} = this.props;

    return (
      <div className="fow-carousel-item-block">
        <div className="fow-inner-container">
          <div className="fow-row">
            <div className="fow-col fow-col-1">
              {showSelected!==false &&
                <SelectedItem />
              }
              {title &&
                <h1 className="fow-font-title fow-font-size-xl fow-carousel-item-block-title">{title}</h1>
              }
            </div>
          </div>
          {subtitle &&
            <div className="fow-row">
              <div className="fow-col fow-col-1">
                <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle">{subtitle}</h2>
              </div>
            </div>
          }
          <div className="fow-row fow-md-row-to-col fow-carousel-item-block-children">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CarouselItem);
